export const DEFAULT_PUBLIC_ORIGIN = 'https://controlvitals.cz';

const BRANDED_HOSTS = new Set([
  'controlvitals.cz',
  'www.controlvitals.cz',
  'controlvitals.com',
  'www.controlvitals.com'
]);

export const normalizePublicOrigin = (value) => {
  if (typeof value !== 'string' || !value.trim()) return null;

  try {
    const parsed = new URL(value.trim());
    if (
      parsed.protocol !== 'https:' ||
      parsed.username ||
      parsed.password ||
      parsed.port ||
      parsed.pathname !== '/' ||
      parsed.search ||
      parsed.hash ||
      !BRANDED_HOSTS.has(parsed.hostname.toLowerCase())
    ) {
      return null;
    }
    return parsed.origin;
  } catch {
    return null;
  }
};

// Keep customer-facing links stable even when the UI is reached through a
// development proxy or a generated deployment hostname.
export const PUBLIC_ORIGIN =
  normalizePublicOrigin(import.meta.env?.VITE_PUBLIC_ORIGIN) ||
  DEFAULT_PUBLIC_ORIGIN;

export const publicUrl = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${PUBLIC_ORIGIN}${normalizedPath}`;
};

const isTechnicalHost = (hostname) => {
  const host = hostname.toLowerCase();
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '[::1]' ||
    host.endsWith('.replit.app') ||
    host.endsWith('.replit.dev') ||
    host.endsWith('.repl.co') ||
    host.endsWith('.repl.run') ||
    host.endsWith('.replusercontent.com')
  );
};

// Generated reports may receive absolute asset URLs from a development proxy.
// Rewrite only known technical hosts; signed storage/CDN URLs and analyzed-site
// URLs remain untouched.
export const publicAssetUrl = (value) => {
  if (typeof value !== 'string' || !value) return value;
  if (value.startsWith('/')) return `${PUBLIC_ORIGIN}${value}`;

  try {
    const parsed = new URL(value);
    if (!isTechnicalHost(parsed.hostname)) return value;
    return `${PUBLIC_ORIGIN}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return value;
  }
};
